import { configureStore } from "@reduxjs/toolkit";

import authReducer from "../features/auth/authSlice";
import adminReducer from "../features/product/productSlice";
import cartReducer from "../features/cart/cartSlice";
import orderReducer from "../features/order/orderSlice";
import searchReducer from "../features/search/searchSlice";
export const store = configureStore({
  reducer: {
    auth: authReducer,
    products: adminReducer,
    cart: cartReducer,
    orders: orderReducer,
    search: searchReducer,
  },
});
